import React from "react";

const Filter = props => {

  return (
    <ul className="filter">
      {props.children}
    </ul>
  );
}

export default Filter;